import * as yup from 'yup';

export enum FieldError {
  Name = 'Name is required.'
}

export const CostCenterValidationSchema = yup.object({
  name: yup.string().required(FieldError.Name)
});

export type CostCenterFormValues = yup.InferType<
  typeof CostCenterValidationSchema
>;
